import React from "react";
import {
  useRouteError,
  isRouteErrorResponse,
  useLocation,
} from "react-router-dom";
import { Button } from "@/components/ui/button";
import Error404 from "@/assets/404-error.svg";

export default function ErrorPage() {
  const error = useRouteError();
  const location = useLocation();

  const customError = location.state?.error ?? {
    message: "Something went wrong",
    title: "Error",
    image: Error404,
  };

  const isDev = process.env.NODE_ENV === "development";

  let title = "Something went wrong";
  let message =
    "We're experiencing technical difficulties. Please try again later.";
  let stack: string | undefined;

  if (isRouteErrorResponse(error)) {
    title = `Error ${error.status}`;
    message = error.statusText;
  } else if (error instanceof Error) {
    message = error.message;
    if (isDev) {
      stack = error.stack;
    }
  }

  return (
    <div className="flex h-screen w-screen items-center justify-center p-10 text-center">
      <div className="w-full bg-white">
        <img
          src={customError.image}
          alt={customError.title}
          className="mx-auto mb-6 max-w-xs"
        />
        <h1 className="mb-4 text-3xl font-bold text-gray-900">{title}</h1>
        {isDev && stack && (
          <div>
            <p className="mb-6 text-gray-800">{message}</p>
            <pre className="mb-6 max-h-60 overflow-auto rounded bg-gray-900 p-4 text-left text-sm text-gray-100">
              {stack}
            </pre>
          </div>
        )}

        <div className="flex justify-center gap-4">
          <Button onClick={() => window.location.reload()}>Refresh</Button>
          <Button onClick={() => (window.location.href = "/")}>Go Home</Button>
        </div>
      </div>
    </div>
  );
}
